import SidebarLayout from "@/components/feature/SidebarLayout";
import { useScrollReveal, getRevealClass } from "@/hooks/useScrollReveal";

export default function Company() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <SidebarLayout breadcrumbs={[{ label: '会社概要' }]}>

      {/* Split Hero */}
      <section className="px-4 md:px-6 lg:px-10 mb-10">
        <div className="relative w-full h-[320px] sm:h-[400px] md:h-[500px] lg:h-[580px] overflow-hidden rounded-2xl">
          <div className="flex w-full h-full">
            {/* Left image */}
            <div className="w-1/2 h-full relative overflow-hidden">
              <img
                src="https://static.readdy.ai/image/8da10c853ee44f0b201c0b84a1169777/781670f8f3d78b3af9c34c2e78ab5210.webp"
                alt="OL Company - Nature"
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
            </div>
            {/* Right image */}
            <div className="w-1/2 h-full relative overflow-hidden">
              <img
                src="https://static.readdy.ai/image/8da10c853ee44f0b201c0b84a1169777/b20889b2f96a458239fbba2304f28fd2.webp"
                alt="OL Company - Talent Management"
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
            </div>
          </div>
          {/* Overlay */}
          <div className="absolute inset-0 bg-black/25" />
          {/* Center text */}
          <div ref={ref} className={`absolute inset-0 flex flex-col items-center justify-center z-10 ${getRevealClass(isVisible)}`}>
            <h1
              className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight"
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              Company
            </h1>
            <p
              className="text-sm sm:text-base md:text-lg text-white mt-3 md:mt-4 tracking-wider"
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              会社概要
            </p>
          </div>
        </div>
      </section>

      {/* Content Card */}
      <div className="px-4 md:px-6 lg:px-10 pb-16 md:pb-24">
        <div className="bg-white rounded-2xl p-8 md:p-12 lg:p-16">
          <div className="max-w-3xl mx-auto">
            {/* Title */}
            <h2
              className="text-2xl md:text-3xl font-bold text-black tracking-wide mb-10"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              会社概要
            </h2>

            {/* Google Map */}
            <div className="w-full aspect-video overflow-hidden rounded-xl mb-10">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3346.985714359207!2d131.5836531!3d32.9777787!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3546c015073efbe5%3A0x35120505f4310b98!2z44CSODc5LTcxMzEg5aSn5YiG55yM6LGK5b6M5aSn6YeO5biC5LiJ6YeN55S65biC5aC077yR77yR77yX77yQ4oiS77yRIOODquODq-ODvOODoOOCueS4iemHjSDnlLosM2Y!5e0!3m2!1sja!2sjp!4v1746583881360!5m2!1sja!2sjp"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="OL Company 本社"
              />
            </div>

            {/* Company Info */}
            <div
              className="space-y-6 text-base text-gray-800 leading-[2]"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              <p>
                <strong className="text-black font-semibold">社名</strong>
                <br />
                株式会社OLカンパニー／OL company Inc.
              </p>
              <p>
                <strong className="text-black font-semibold">代表者取締役</strong>
                <br />
                森祐作
              </p>
              <p>
                <strong className="text-black font-semibold">役員</strong>
                <br />
                川野嘉之
              </p>
              <div>
                <p className="mb-1">
                  <strong className="text-black font-semibold">所在地</strong>
                </p>
                <p className="text-gray-700">
                  本社　大分県豊後大野市三重町市場1170-1リルームス三重町3F
                </p>
                <p className="text-gray-700">
                  臼杵オフィス　大分県臼杵市大字深江1108番地
                </p>
                <p className="text-gray-700">
                  蒲江オフィス　大分県佐伯市蒲江大字蒲江浦2215-6ヤマモトビル2F
                </p>
              </div>
              <p>
                <strong className="text-black font-semibold">設立日</strong>
                <br />
                2021年9月13日
              </p>
              <p>
                <strong className="text-black font-semibold">資本金</strong>
                <br />
                1,200,000円
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Contact CTA */}
      <div className="px-4 md:px-6 lg:px-10 pb-16 md:pb-24">
        <div className="bg-[#025ab0] rounded-2xl p-8 md:p-12 lg:p-16">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-8 max-w-5xl mx-auto">
            <div>
              <h2
                className="text-2xl md:text-3xl font-bold text-white tracking-wide mb-2"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                お問い合わせ
              </h2>
              <p
                className="text-white/80 text-sm md:text-base"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                お客様からのお問い合わせをお待ちしております。お気軽にご連絡ください。
              </p>
            </div>
            <a
              href="/contact"
              className="inline-flex items-center gap-2 px-8 py-3 bg-white text-[#025ab0] text-sm font-medium rounded-full hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              お問い合わせ
            </a>
          </div>
        </div>
      </div>
    </SidebarLayout>
  );
}